"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const services = ["Portable Toilets", "ADA Compliant Units", "Luxury Restroom Trailers", "Shower Trailers", "Handwash Stations", "Event Sanitation Solutions"];
const socials = [{
  icon: Facebook,
  href: "#",
  label: "Facebook"
}, {
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}, {
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted/20 animate-pulse rounded-md" />)}
      </div>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors font-sans text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section id="footer" className="dark bg-background text-foreground pt-16 pb-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="inline-block mb-6">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636043/img/pottyforsale_logo_dark.png" alt="PottyForSale.com" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground font-sans text-sm leading-relaxed max-w-xs">
              National Portable Sanitation Solutions. Fast, Reliable, Anywhere. Providing premium logistics and enterprise-level site services nationwide.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={service} data-index={i}>
                  <Link to="#" className="text-muted-foreground hover:text-primary transition-colors font-sans text-sm">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6">Corporate</h3>
            <MenuProvider menu_id="2">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6">Contact</h3>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start gap-3 text-muted-foreground font-sans text-sm">
                <MapPin className="size-5 shrink-0 text-primary" />
                <span>Nationwide Service Network, USA</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground font-sans text-sm">
                <Phone className="size-5 shrink-0 text-primary" />
                <span>(800) 555-PORT</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground font-sans text-sm">
                <Mail className="size-5 shrink-0 text-primary" />
                <span>sales@pottyforsale.com</span>
              </li>
            </ul>

            <div className="flex items-center gap-4">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.href} data-index={i} className="size-10 rounded-full bg-muted/10 flex items-center justify-center text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-colors" aria-label={social.label}>
                    <Icon className="size-4" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        <Separator className="bg-border/50 mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-muted-foreground font-sans">
          <p>© {new Date().getFullYear()} PottyForSale.com. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}